import * as React from "react";
import { withRouter } from "react-router-dom";
import axios from "../res/axios";
import { bindActionCreators } from "redux";
import * as actionCreators from "../res/actions";
import { connect } from "react-redux";
import {
  challenge_newbie,
  challenge_pro,
  service_all_star,
  lab_builder,
  deep_dive,
} from "../../assets/img";
import {
  Icon,
  Popover,
  Button,
  ProgressBar,
  Modal,
  Flash,
  ColumnLayout,
  Spinner,
} from "@amzn/awsui-components-react/polaris/";

const mapStateToProps = (state) => {
  return {
    user: state.appState.user,
    badgelist: state.badgelist,
    loading: state.appState.isLoading,
    serverClientTimeOffset: state.appState.serverClientTimeOffset,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      addNotification: actionCreators.addNotification,
      setBadges: actionCreators.setBadges,
      setLoggedInUser: actionCreators.setLoggedInUser,
      setServerClientTimeOffset: actionCreators.setServerClientTimeOffset,
    },
    dispatch
  );
};

let data = "";

class MyBadges extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      info_visible: false,
      progress_visible: false,
    };
  }

  toggleInfoVisible = () => {
    this.setState((prevState) => ({ info_visible: !prevState.info_visible }));
  };
  toggleProgressVisible = () => {
    this.setState((prevState) => ({
      progress_visible: !prevState.progress_visible,
    }));
  };

  componentDidMount() {
    if (this.props.badgesStatus !== true) {
      this.setState({
        loading: true,
      });
      let headers = {
        "x-csrf-token": localStorage.getItem("BOTSE_SESSION_TOKEN"),
        Action: "Atari:GetBadges",
      };

      axios
        .get("action", { headers: headers })
        .then((res) => {
          res.data = JSON.parse(res.data);
          data = res.data;
          console.log(data);
          this.props.setBadges(data);
          this.props.badgesStatus = true;
          this.setState({
            loading: false,
          });
        })
        .catch((error) => {
          this.props.badgesStatus = false;
          this.setState({
            loading: false,
          });
          // console.log(error);
          // var notification = {
          //   id: 1,
          //   type: "error",
          //   dismissible: true,
          //   header: "Failed to fetch the badges list!",
          //   content: "Please try reloading the page, or submit a ticket if this issue persists.",
          // };
          // this.props.addNotification(notification);
        });
      console.log(data);
    }
  }

  render() {
    function makeBadgeImg(badgeId, info_object) {
      var tmpSrc;
      switch (badgeId) {
        case "deep-dive":
          tmpSrc = deep_dive;
          break;
        case "challenge-newbie":
          tmpSrc = challenge_newbie;
          break;
        case "challenge-pro":
          tmpSrc = challenge_pro;
          break;
        case "service-all-star":
          tmpSrc = service_all_star;
          break;
        case "lab-builder":
          tmpSrc = lab_builder;
          break;
        default:
          return;
      }
      var info_array = [];
      for (var single_badge of info_object) {
        info_array.push(
          <div className="awsui-util-status-positive">
            <Icon variant="success" name="unlocked"></Icon>
            {single_badge["attribute"]} Earned: {single_badge["issue_date"]}
          </div>
        );
      }
      return (
        <Button variant="link">
          <Popover
            position="bottom"
            triggerType="custom"
            dismissButton={false}
            content={info_array}
          >
            <img src={tmpSrc} alt="bottlenose badge" height="120px" width="120px" className="badge" />
          </Popover>
        </Button>
      );
    }

    const info_button = (
      <Button icon="status-info" onClick={this.toggleInfoVisible} />
    );
    const progress_button = (
      <Button
        variant="normal"
        icon="status-in-progress"
        onClick={this.toggleProgressVisible}
      >
        Badge Progress
      </Button>
    );
    const info_modal = (
      <Modal
        header="Badge Information"
        onDismiss={this.toggleInfoVisible}
        visible={this.state.info_visible}
      >
        <h5>
          Badges, displayed on the home menu, can be earned by completing any of
          the below listed tasks.
        </h5>
        <p>
          - Challenge Newbie - Awarded for the first challenge passed in a new
          profile.
          <br />
          - Challenge Pro - Awarded for every 5 unique challenges passed.
          <br />
          - Deep Dive - Awarded for passing 7 unique challenges in a profile.
          <br />- Service All Star - Awarded for passing all challenges in a
          profile.
        </p>
      </Modal>
    );
    const badge_object = this.props.badgelist.badgelist;
    const progress_object = this.props.badgelist.progress;
    const badge_array = [];
    const progress_array = [];
    var badgeless;
    var badge_bar;
    function makeProgressArray(value, index, array) {
      if (value["value"] === "None"){
        return;
      }
      progress_array.push(
        <div>
          <ProgressBar
            label={value["name"]}
            value={value["value"]}
          ></ProgressBar>
        </div>
      );
    }
    if (typeof progress_object !== "undefined") {
      progress_object.forEach(makeProgressArray);
    }
    const progress_modal = (
      <Modal
        onDismiss={this.toggleProgressVisible}
        visible={this.state.progress_visible}
      >
        {progress_array}
      </Modal>
    );
    if (typeof badge_object !== "undefined") {
      for (var badgeId of Object.keys(badge_object)) {
        badge_array.push(makeBadgeImg(badgeId, badge_object[badgeId]));
      }
      if (badge_array.length === 0) {
        badgeless = (
          <Flash>
            Your achievements within Bottlenose will be displayed here. For
            information on specific badges you can earn, click the above
            information button.
          </Flash>
        );
      }
    }
    if (this.state.loading) {
      badge_bar = (
        <div className="badge-bar">
          <Spinner size="large"></Spinner>
        </div>
      );
    } else {
      badge_bar = (
        <div className="badge-bar">
          <div>
            {info_button}
            {info_modal}
          </div>
          <div className="no-badges">{badgeless}</div>
          <div className="badge-container">{badge_array}</div>
          <div>
            {progress_button}
            {progress_modal}
          </div>
        </div>
      );
    }

    return (
      <ColumnLayout columns={2} className="badge-column">
        <div data-awsui-column-layout-root="true">
          <div></div>
          {badge_bar}
        </div>
      </ColumnLayout>
    );
  }
}

const MyBadgesWithRouter = withRouter(MyBadges);
export default connect(mapStateToProps, mapDispatchToProps)(MyBadgesWithRouter);



// WEBPACK FOOTER //
// ./src/app/components/MyBadges.jsx